import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-7628b29f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-content-header" }
const _hoisted_4 = { class: "modal-content-header-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-title" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  href: "/modules/vuejs/vuejs-app/dist/Entyvio-Abbreviated-Product-Information-dk.pdf",
  target: "_blank",
  class: "nav-link"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_11 = { class: "modal-content-text" }
const _hoisted_12 = {
  key: 0,
  class: "btn-empty text-s",
  "data-bs-dismiss": "modal"
}
const _hoisted_13 = ["data-bs-dismiss"]

import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    validateBtnText: null,
    cancelBtnText: null,
    disableDismiss: { type: Boolean }
  },
  emits: ['onCancelClick', 'onValidateClick'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  title: string
  validateBtnText?: string
  cancelBtnText?: string
  disableDismiss?: boolean
}





const modal = ref<HTMLElement | null>(null)

const closeButton = ref<HTMLElement | null>(null)

const isShown = ref(false)

onMounted(() => {
  modal.value?.addEventListener('show.bs.modal', () => {
    isShown.value = true
  })

  modal.value?.addEventListener('hide.bs.modal', () => {
    isShown.value = false
    emit('onCancelClick')
  })
})

async function getModalInstance() {
  if (modal.value != null) {
    const { Modal } = await import('bootstrap')

    const modalInstance = new Modal(modal.value)
    if (!modalInstance) {
      return null
    }

    return modalInstance
  }

  return null
}

function onValidateClick() {
  emit('onValidateClick')
}

async function show() {
  // eslint-disable-next-line @typescript-eslint/no-extra-semi
  ;(await getModalInstance())?.show()
}

async function hide() {
  closeButton?.value?.click()
}

expose({
  show,
  hide,
  isShown,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modal",
    ref: modal,
    class: "modal fade",
    role: "dialog",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", {
              innerHTML: props.title
            }, null, 8, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("button", {
            ref_key: "closeButton",
            ref: closeButton,
            class: "btn btn-icon",
            "data-bs-dismiss": "modal"
          }, _hoisted_8, 512)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, [
              _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('header.prescribingInformation')), 1)
            ])
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (__props.validateBtnText)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["modal-content-footer", { 'modal-content-footer-multiple-btn': props.cancelBtnText }])
            }, [
              (props.cancelBtnText)
                ? (_openBlock(), _createElementBlock("button", _hoisted_12, _toDisplayString(props.cancelBtnText), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-md btn-primary",
                "data-bs-dismiss": props.disableDismiss ? '' : 'modal',
                onClick: onValidateClick
              }, _toDisplayString(props.validateBtnText), 9, _hoisted_13)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}
}

})